const getLocalShowBillButton = () => {
  const val = localStorage.getItem("showBillButton");
  return val === null ? true : val === "true";
};
export default getLocalShowBillButton;
